import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

/* Views */
import Dashboard from "../views/dashboard/Dashboard";
import Tools from "../views/dashboard/Tools";
import JSONPrettyPrint from "../views/dashboard/JSON-Pretty-Print";
import Base64EncoderDecoder from "../views/dashboard/Base-64-Encoder-Decoder";
import SitemapAnalyzer from "../views/dashboard/Sitemap-Analyzer";
import WebpageAnalyzer from "../views/dashboard/Webpage-Analyzer";
import JSONPath from "../views/dashboard/JSON-Path";
import UUIDGenerator from "../views/dashboard/UUID-Generator";
import QRCodeGenerator from "../views/dashboard/QR-Code-Generator";
import SQLFormatter from "../views/dashboard/SQL-Formatter";
import PasswordGenerator from "../views/dashboard/Password-Generator";
import UrlEncoder from "../views/dashboard/Url-Encoder";
import TimestampConverter from "../views/dashboard/Timestamp-Converter";
import Normalizer from "../views/dashboard/Normalizer";
import JWTDebugger from "../views/dashboard/JWT-Debugger";
import FileConverter from "../views/dashboard/File-Converter";
import DataTable from "../views/dashboard/DataTable";
import ExplanationUI from "../views/dashboard/ExplanationUI";
import QSFExplainUI from "../views/dashboard/QSFExplainUI";
import QSCExplainGraph from "../views/dashboard/QSFExplainGraph";

import QueueUp from "../views/queue-up/Queue-Up";
import QueueUpScan from "../views/queue-up/Queue-Up-Scan-Page";
import QueueUpConfirm from "../views/queue-up/Queue-Up-Confirm-Page";
import QueueUpStatus from "../views/queue-up/Queue-Up-Status-Page";
import QueueUpDisplay from "../views/queue-up/Queue-Up-Display-Page";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    children: [
      {
        path: "/",
        name: "Tools",
        component: Tools,
      },
      {
        path: "/json-pretty-print",
        name: "JSON Pretty",
        component: JSONPrettyPrint,
      },
      {
        path: "/base-64-encode-decode",
        name: "Base 64 Encode-Decode",
        component: Base64EncoderDecoder,
      },
      {
        path: "/sitemap-analyzer",
        name: "Sitemap Analyzer",
        component: SitemapAnalyzer,
      },
      {
        path: "/webpage-analyzer",
        name: "Webpage Analyzer",
        component: WebpageAnalyzer,
      },
      {
        path: "/json-path",
        name: "JSON Path",
        component: JSONPath,
      },
      {
        path: "/uuid-generator",
        name: "UUID Generator",
        component: UUIDGenerator,
      },
      {
        path: "/qr-code-generator",
        name: "QR Code Generator",
        component: QRCodeGenerator,
      },
      {
        path: "/sql-formatter",
        name: "SQL Formatter",
        component: SQLFormatter,
      },
      {
        path: "/password-generator",
        name: "Password Generator",
        component: PasswordGenerator,
      },
      {
        path: "/url-encoder",
        name: "Url Encoder",
        component: UrlEncoder,
      },
      {
        path: "/timestamp-converter",
        name: "Timestamp Converter",
        component: TimestampConverter,
      },
      {
        path: "/normalizer",
        name: "Normalizer",
        component: Normalizer,
      },
      {
        path: "/jwt-debugger",
        name: "JWT Debugger",
        component: JWTDebugger,
      },
      {
        path: "/file-converter",
        name: "File Converter",
        component: FileConverter,
      },
      {
        path: "/data-table",
        name: "Data Table",
        component: DataTable,
      },
      {
        path: "/ExplanationUI",
        name: "ExplanationUI",
        component: ExplanationUI,
      },
      {
        path: "/QSFExplainUI",
        name: "QSF Explain UI",
        component: QSFExplainUI,
      }
      ,
      {
        path: "/QSFExplainGraph",
        name: "QSF Explain Graph",
        component: QSCExplainGraph,
      }
    ],
  },
  {
    path: "/queue-up",
    name: "Queue Up",
    component: QueueUp,
    redirect: "/queue-up/scan/:tenantCode/:code",
    children: [
      {
        path: "/queue-up/scan/:tenantCode/:code",
        name: "Scan",
        component: QueueUpScan,
      },
      {
        path: "/queue-up/confirm/:tenantCode/:code/:id",
        name: "Confirm",
        component: QueueUpConfirm,
      },
      {
        path: "/queue-up/status/:tenantCode/:code/:id",
        name: "Status",
        component: QueueUpStatus,
      },
      {
        path: "/queue-up/display/:tenantCode/:code",
        name: "Display",
        component: QueueUpDisplay,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes,
});

export default router;
